/**
 * 所有设置页面路由
 * [ 当前页面处于设置页面，点击header或nav则显示modal提示 ]
 */

export default {
  isShowModal: ['analytics/behavior/funnel/setFunnel', 'account/main/index/edit', 'user/group/edit'],
};
